import { getApiClient } from '../services/api';
import { type TRightDisplay } from '../store/rights';
import { IDataBasic } from '../types/base';
import { IRightsType } from '../types/enums';

// 类型定义
interface IRightsDisplayParams {
  faq?: boolean;
  rights_type?: string;
}

interface IGetRightsCreditCoinsPackageParams {
  many: string;
  rights_type: IRightsType;
  use_cache?: number;
}

export interface IRightsIsInCampaign {
  flag: boolean;
  start_time: string;
}

// 言币加油包
export interface ICreditCoinsPackage extends IDataBasic {
  rights_template_id: number;
  title: string;
  sub_title: string;
  price: number;
  org_price_description: string;
  credit_coins: number;
  free_credit_coins: number;
  total_credit_coins: number;
  idx: number;
}

// API 方法
export const getRightsDisplay = async (params?: IRightsDisplayParams) => {
  const client = await getApiClient();
  return client.get<TRightDisplay>(
    '/rights/display/',
    { many: true, ...params },
    { autoErrorHandle: false },
  );
};

export const getRightsCreditCoinsPackage = async (params: IGetRightsCreditCoinsPackageParams) => {
  const client = await getApiClient();
  return client.get<ICreditCoinsPackage[]>('/rights/credit_coins_package/', params);
};

// 权益分层的弹窗公告信息 - 活动接口

export const getRightsIsInCampaign = async () => {
  const client = await getApiClient();
  return client.get<IRightsIsInCampaign>('/rights/is_in_campaign/');
};

export const postCampaignConfirm = async () => {
  const client = await getApiClient();
  return client.post('/rights/campaign_confirm/');
};
